import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { SessionService } from '../../services/session/session.service';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-master-accounts',
    templateUrl: './master-accounts.component.html',
    styleUrls: ['./master-accounts.component.css'],
    standalone: false
})
export class MasterAccountsComponent implements OnInit {
  @Output() clickDoneEvent = new EventEmitter<any>();
  addBankSubmitted: boolean = false;
  cashAccForm: FormGroup = new FormGroup({});
  isSuccessful: boolean = false;
  isSignUpFailed: boolean = true;
  errorMessage: string = '';
  loading: boolean = false;
  initialLoading: boolean = false;
  isLoggedIn: boolean = false;
  role: string = '';
  user: any;
  masterAccCreated: boolean = false;
  customerId: number = -1;
  customerNumber!: string;
  currencyList: any;
  cashAccountList: any=[];
  exchangeAccountList: any=[];
  securityAccountList: any=[];
  exchanges: any=[];
  brokers: any=[];
  createAccClicked: boolean = false;
  createCashAccountClicked: boolean = false;
  createSecurityAccountClicked: boolean = false;
  createExchangeAccClicked: boolean = false;
  securityAccLocked: boolean = false;
  exchangeAccLocked: boolean = false;
  isAllDone: boolean = false;
  exchangeCode: any;
  env:any;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private tokenStorage: TokenStorageService,
    private userService: UserService,
    private router: Router,
    private sessionStorageService: SessionService,

  ) { }

  ngOnInit(): void {
    this.initializeCashAccForm();
    this.env = this.tokenStorage.getUserEnv();


    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.user = this.tokenStorage.getUser().username;
      this.role = this.user.role;
    }
    this.getCurrencyList()
  }

  show(customerId: number, customerNumber: string) {
    this.customerId = customerId
    this.customerNumber = customerNumber
    this.masterAccCreated = true
    // this.getCurrencyList()
  }

  getCurrencyList() {
    this.initialLoading = true;
    this.userService.getCurrencyList().subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.currencyList = data.list.sort((a: any, b: any) =>
            a.type > b.type ? 1 : -1
          );
        } else {
          this.errorMessage = data.reason;
          this.toastr.error(
            this.errorMessage,
            'Error getting currency list'
          );
        }
        this.initialLoading = false;
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(
          this.errorMessage,
          'Error getting currency list'
        );
        this.initialLoading = false;
      },
    });
  }

  onSelectExchange(event :any){

    this.exchangeCode = event.target.value;
    this.getExecutingBrokerList(this.exchangeCode);
  }

  initializeCashAccForm(): void {
    this.cashAccForm = this.formBuilder.group({
      masterAccCashAccCurrency: ['', [Validators.required]],
      masterAccCashAccId: ['', [Validators.required]],
      masterAccSecurityAccType: ['', [Validators.required]],
      masterAccSecurityAccId: ['', [Validators.required]],
      masterAccExchangeAccExchange: ['', [Validators.required]],
      masterAccExchangeAccExecBroker: ['', [Validators.required]],
    });
  }
  createSecurityAccount(){
    this.createSecurityAccountClicked = true;
    this.loading = true;
    if (this.cashAccForm.invalid && this.formBankControl['masterAccSecurityAccType'].errors) {
      this.loading = false
      return;
    }

    const {
      masterAccSecurityAccType,
      masterAccCashAccId
    } = this.cashAccForm.value

    this.userService.createSecurityAccount(masterAccCashAccId, masterAccSecurityAccType)
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.exchanges=[]
            this.getInstExchangeList();
            this.toastr.success(data.reason, 'Success');
            this.exchangeAccLocked = true
            this.securityAccountList.push({accountNumber: data.accountNumber, accountType: masterAccSecurityAccType,cashAccId:masterAccCashAccId})
            // TODO : Create a list & add newly created cash accounts to that
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create security account'
            );
          }
          this.loading = false;
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create security account'
          );
          this.loading = false;
        },
      });
  }
  createCashAccount() {
    this.createCashAccountClicked = true;
    this.loading = true;
    if (this.cashAccForm.invalid && this.formBankControl['masterAccCashAccCurrency'].errors) {
      this.loading = false
      return;
    }

    const {
      masterAccCashAccCurrency
    } = this.cashAccForm.value

    this.userService.createCashAccount(this.customerNumber, masterAccCashAccCurrency)
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.toastr.success(data.reason, 'Success');
            this.securityAccLocked = true
            this.cashAccountList.push({currency: masterAccCashAccCurrency, accountNumber: data?.cashAccountNumber})

            // TODO : Create a list & add newly created cash accounts to that
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create cash account'
            );
          }
          this.loading = false;
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create cash account'
          );
          this.loading = false;
        },
      });
  }
  createExchangeAccount(){
    this.createExchangeAccClicked = true;
    this.loading = true;
    if (this.cashAccForm.invalid && this.formBankControl['masterAccExchangeAccExchange'].errors) {
      this.loading = false
      return;
    }

    const {
      masterAccExchangeAccExchange,
      masterAccSecurityAccId,
      masterAccExchangeAccExecBroker
    } = this.cashAccForm.value

    this.userService.createExchangeAccount(masterAccSecurityAccId, masterAccExchangeAccExchange, masterAccExchangeAccExecBroker, 'YES')
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.toastr.success(data.reason, 'Success');
            this.exchangeAccountList.push({exchange: masterAccExchangeAccExchange, accountNumber: data?.exchangeAccountId , securityAccId:masterAccSecurityAccId})
            this.isAllDone = true

            this.userService.exchangeAccTradinEnable(data?.exchangeAccountId, 1).subscribe({
              next: (data: any) => {
                if (data.status == 'SUCCESS') {
                  console.log(data, 'Succsesfully Trading enabled');
                }
              },
              error: (err: any) => {
                console.log(err.error.message, 'Error');
              },
            });

          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create exchange account'
            );

          }


          this.loading = false;
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create exchange account'
          );
          this.loading = false;
        },
      });
  }
  getInstExchangeList(): void {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.userService.getInstExchangesList(instCode, 'asia').subscribe({
      next: (data: any) => {
        if (data.status == 'SUCCESS') {
          this.exchanges = data?.list;

          this.loading = false;
        }
      },
      error: (err: any) => {
        console.log(err.error.message, 'Error');
      },
    });
  }

  getExecutingBrokerList(exchangeCode : any): void {
    this.userService.getExecutingBrokerList(exchangeCode).subscribe({
      next: (data: any) => {
        if (data.status == 'SUCCESS') {
          this.brokers = data?.list;

          this.loading = false;
        }
      },
      error: (err: any) => {
        console.log(err.error.message, 'Error');
      },
    });
  }

  reloadPage(): void {
    window.location.reload();
  }

  get formBankControl(): { [key: string]: AbstractControl } {
    return this.cashAccForm.controls;
  }

}
